import React from "react"
import { isMobile } from "react-device-detect"
import ActivityFeed from "../../components/home/components/ActivityFeed"
import ShowOfTheWeekSidebar from "../../components/home/components/ShowOfTheWeekSidebar"
import UserCalendar from "../../components/home/components/UserCalendar"
import Footer from "../../components/shared/Footer/Footer"
import HeadlinePostForm from "../../components/HeadlinePostForm"
import EventForm from "../../components/EventForm"
import Header from "../../components/shared/Header/Header"
import Heading from "../../components/shared/Heading"
import MakeStuff from "../../components/home/components/MakeStuff"

const NewPostPage = ({ user, isEvent }) => {
  return (
    <div className="">
      <Header user={user} />
      <div className="lg:grid lg:grid-cols-12 w-full pb-2 mt-4 px-3 lg:px-4 flex flex-col-reverse">
        <div className="lg:col-span-4 col-span-12 lg:pr-6">
          <div className="text-xs text-white uppercase leading-none">
            Create Your Event or Post in bandNada
          </div>
          <MakeStuff />
          <ShowOfTheWeekSidebar className="mb-6" />
          {user && (
            <div className="mb-6">
              <UserCalendar user={user} />
            </div>
          )}
          {user && user.enable_activity_feed && !isMobile && (
            <div className="">
              <ActivityFeed />
            </div>
          )}
        </div>
        <div className="lg:col-span-8 col-span-12 lg:mt-0">
          <div className="text-xs text-white uppercase leading-none">
            Create Your Event or Post in bandNada
          </div>
          <Heading
            level={2}
            type="sectionHeader"
            className="flex justify-between"
          >
            Post Your {isEvent ? "Event" : "Thing"}
          </Heading>
          {isEvent ? <EventForm /> : <HeadlinePostForm bandId={user.band_id} />}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default NewPostPage
